import feature from './feature';
import contact from './contact';
import social from './social';
import quote from './quote';

export default {
  feature,
  contact,
  social,
  quote,
};
